import { setUserProfile } from "app/features/profile";
import { useAppDispatch } from "app/hooks";
import axios from "axios";
import { createContext} from "react";

interface ProfileContextType {
  fetchUserProfile: () => Promise<void>;
}

export const ProfileContext = createContext<ProfileContextType>(
  {} as ProfileContextType
);

interface Props {
  children: React.ReactNode;
}

export const ProfileContextProvider = ({ children }: Props) => {
  const dispatch = useAppDispatch();

  const fetchUserProfile = async () => {
    try {
      const { data } = await axios.get(process.env.REACT_APP_AUTH_BASE_URL + "/user/profile");
      dispatch(setUserProfile(data));
    } catch (_err) {
      // console.log(error);
    }
  };

  return (
    <ProfileContext.Provider value={{ fetchUserProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};
